import styled from "styled-components";
import media from "styled-media-query";

export const Wrapper = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;

  form {
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 100%;
  }
`;

export const Section = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: 10px;

  margin-top: 20px;

  span {
    font-size: 18px;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.primary.vividCerulean};
  }

  hr {
    border: 1px solid ${({ theme }) => theme.colors.primary.vividCerulean};
    width: 100%;
  }
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  gap: 10px;
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  width: 100%;

  margin-bottom: 20px;

  span {
    font-size: 16px;
  }
`;

export const QuotasWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  width: 70%;

  margin-bottom: 20px;

  ${media.lessThan("medium")`
    width: 100%;
    flex-wrap: wrap;
  `}
`;

export const QuotaColumns = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 10px;
  align-items: center;

  width: 100%;

  h3 {
    font-size: 14px;
  }
`;

export const Quota = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 10px;
  align-items: center;

  width: 100%;

  span {
    font-size: 14px;
  }
`;

export const Uf = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const Cities = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
`;

export const City = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.neutral.black};

  display: flex;
  align-items: center;
  gap: 5px;
`;

export const File = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  padding: 10px;
  border: 1px solid ${({ theme }) => theme.colors.neutral.white};
  border-radius: 5px;

  h2 {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.neutral.black};
  }
`;

export const FileInfos = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Tabs = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const Conversations = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 10px;
  align-items: center;

  ${media.lessThan("medium")`
    grid-template-columns: 1fr;
  `}
`;

export const Conversation = styled.div`
  /* ⚠️ position relative ancora o ConversationBadge no card. Sem ele o badge
     se posiciona pelo ancestral posicionado mais proximo e sai flutuando. */
  position: relative;

  display: flex;
  align-items: flex-start;
  gap: 10px;

  min-height: 72px;

  padding: 10px;
  border: 2px solid ${({ theme }) => theme.colors.primary.green};

  cursor: pointer;

  :hover {
    opacity: 0.8;
  }
`;

/*
 * Quantas mensagens desta conversa aguardam a avaliação do admin (24/09/2026).
 *
 * O botão "Mensagens" já dizia QUANTAS pendências o projeto tem; com mais de
 * uma conversa, não dizia ONDE. Mesma geometria e mesmo token de cor do
 * TabBadge dos botões das sessões (Details/styles.js) — são o mesmo indicador
 * em dois níveis, e divergir visualmente sugeriria que medem coisas diferentes.
 *
 * `feedbackState.critical.default` é o único vermelho presente nos DOIS temas.
 */
export const ConversationBadge = styled.span`
  position: absolute;
  top: -6px;
  right: -6px;
  z-index: 1;

  min-width: 20px;
  height: 20px;
  padding: 0 5px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 10px;

  background-color: ${({ theme }) =>
    theme.colors.feedbackState.critical.default};
  color: ${({ theme }) => theme.colors.neutral.white};

  font-size: 11px;
  font-weight: 700;
  line-height: 1;
`;

export const ConversationInfos = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  width: 100%;

  h2 {
    color: ${({ theme }) => theme.colors.primary.vividCerulean};
    font-size: 20px;
  }

  h3 {
    color: ${({ theme }) => theme.colors.neutral.gray8};
    font-size: 16px;
  }

  span {
    font-size: 14px;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  h2 {
    font-size: 16px;
    color: ${({ theme }) => theme.colors.neutral.white};
    font-weight: 700;
  }

  p {
    color: ${({ theme }) => theme.colors.neutral.cinza600};
  }
`;
